export default [{
  path: '/advanceSalary',
  name: 'advanceSalary',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/advanceSalary/index')
}]
